import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import List from "./list";

export default function UsersGroupsCars(props) {
    const { clearParams } = props;

    useEffect(() => {
        return () => {
            clearParams("users-groups-cars");
        };
    }, []);

    return (
        <div className="page-content">
            <List
                {...props}
                isTable
                transition="full"
                title="Список машин в группах"
                nofilter
                back={() => props.history.push(paths.usersGroups)}
            />
        </div>
    );
}
